<template>
  <section
    class="layout-pt-lg layout-pb-lg"
    :style="`background-color: var(--c-${vars.backgroundColor})`"
  >
    <div class="container">
      <!-- Başlık -->
      <div class="row justify-between items-center">
        <div class="col-auto">
          <div v-html="vars.titleHtml" />
        </div>
      </div>

      <!-- Masaüstü & tablet -->
      <div data-anim-wrap class="desktop-only row y-gap-30 pt-60 md:pt-30">
        <div
          v-for="(card, index) in cards"
          :key="index"
          class="col-lg-4 col-md-6"
        >
          <div
            :data-anim-child="`slide-up delay-${index + 1}`"
            class="hover-icon-1 px-40 py-40 md:px-30 border border-accent-1 flex flex-col"
            style="height: 480px;"
          >
            
            <h3 class="text-20">{{ card.title }}</h3>
          
            <p class="text-base">{{ card.description }}</p>
          </div>
        </div>
      </div>

      <!-- Mobil -->
      <div class="mobile-only pt-60">
        <div
          class="relative js-section-slider"
          data-gap="0"
          data-slider-cols="sm-1,base-1"
        >
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(card, index) in cards"
              :key="index"
            >
              <div
                class="hover-icon-1 border border-accent-1 px-30 py-30 flex flex-col"
                style="height: 380px;"
              >
                <!-- Başlık en üst -->
                <h3 class="text-18">{{ card.title }}</h3>
                <!-- Açıklama en altta -->
                <p class="text-sm">{{ card.description }}</p>
              </div>
            </div>
          </div>

          <!-- Slider okları -->
          <div class="d-flex justify-start mt-30">
            <button class="sliderNav -prev -transparent mr-15 js-prev">
              <i class="icon-left-arrow"></i>
            </button>
            <button class="sliderNav -next -transparent ml-15 js-next">
              <i class="icon-right-arrow"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'OurGuide',
  mixins: [ComponentMixin],

  computed: {
    cards() {
      return this.groupedVariables.cards;
    }
  }
});
</script>

<style scoped>
.border-accent-1 {
  --tw-border-opacity: 1;
  border-color: #DDDDDD !important;
}


.hover-icon-1 {
  display: flex;
  flex-direction: column;
}

.hover-icon-1 h3,
.hover-icon-1 p {
  margin: 0;
}

.hover-icon-1 p {
  margin-top: auto;
}


@media (max-width: 767px) {
  .desktop-only {
    display: none !important;
  }
}

@media (min-width: 768px) {
  .mobile-only {
    display: none !important;
  }
}
</style>
